import { ArgumentError } from "../../../utils/errors.mjs";
import shortUInt from "./short-u-int.mjs";
export default function genShortUIntConstField(constValue, optional) {
  return {
    serialize(value) {
      if ((optional !== true || value != null) && value !== constValue) {
        throw new ArgumentError('ShortUIntConst', constValue, value);
      }
      return shortUInt.serialize(constValue);
    },
    deserialize(buf) {
      const value = shortUInt.deserialize(buf);
      if (value !== constValue) throw new ArgumentError('ShortUIntConst', constValue, value);
      return constValue;
    },
    constValue,
    constValueOptional: optional === true
  };
}
//# sourceMappingURL=short-u-int-const.mjs.map